var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "xh-files-cont xh-form-border",
      class: [_vm.disabled ? "is_disabled" : "is_valid"],
    },
    [
      _c(
        "flexbox",
        {
          staticClass: "f-header",
          class: [_vm.disabled ? "is_disabled" : "is_valid"],
          nativeOn: {
            click: function ($event) {
              return _vm.selectImage.apply(null, arguments)
            },
          },
        },
        [
          !_vm.disabled
            ? _c("i", { staticClass: "wukong wukong-file f-logo" })
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "f-name" }, [_vm._v("附件")]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "f-body" },
        _vm._l(_vm.dataValue, function (item, index) {
          return _c("flexbox", { key: index, staticClass: "f-item" }, [
            _c("i", { staticClass: "wukong wukong-file f-img" }),
            _vm._v(" "),
            _c("div", { staticClass: "f-name" }, [
              _vm._v(_vm._s(_vm._f("fileName")(item))),
            ]),
            _vm._v(" "),
            !_vm.disabled
              ? _c(
                  "div",
                  {
                    staticClass: "close-button",
                    on: {
                      click: function ($event) {
                        return _vm.deleteFile(item, index)
                      },
                    },
                  },
                  [_vm._v("×")]
                )
              : _vm._e(),
          ])
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }